// extracted by mini-css-extract-plugin
export default {"WeirdFlex":"WeirdFlex_WeirdFlex__6N+UN"};